import normalizingFetch from 'lib/normalizingFetch';
import qs from 'lib/normalizingQs';

export const login = async ({ identifier, password }) =>
  await normalizingFetch(process.env.REACT_APP_API_LOGIN, {
    method: 'POST',
    body: {
      user: {
        email: identifier,
        password,
      },
    },
    detailedResponse: true,
  });

export const signup = async user =>
  await normalizingFetch(process.env.REACT_APP_API_SIGNUP, {
    method: 'POST',
    body: user,
    detailedResponse: true,
  });

export const logout = async ({ authorization }) =>
  await normalizingFetch(process.env.REACT_APP_API_LOGIN, {
    method: 'DELETE',
    detailedResponse: true,
    headers: {
      authorization,
    },
  });

export const getTerms = async ({ query }) =>
  await normalizingFetch(
    `${process.env.REACT_APP_API_TERMS}?${qs.stringify(query)}`,
    {
      method: 'GET',
      detailedResponse: true,
    },
  );

export const sendMagicLink = async email =>
  await normalizingFetch(process.env.REACT_APP_API_MAGIC_LINK, {
    method: 'POST',
    body: { user: { email } },
    detailedResponse: true,
  });

export const keepUserLogin = async () =>
  normalizingFetch(process.env.REACT_APP_API_SESSION, {
    method: 'POST',
    detailedResponse: true,
    body: { cookie_login: true },
  });
